export default [
    {
        id: 'auxiliaries2',
        title: '  |  ',
        route: null,
        permission: 'view_auxiliars_vhe',
    },

    //VHE
    {
        header: 'Auxiliares 2',
        permission: 'view_auxiliars_vhe',
        children: [
            {
                title: 'Gestor Responsable',
                route: 'auxiliar2_list_responsible_manager_vhe',
                permission: 'view_auxiliars_vhe',
            },
            {
                title: 'Gestor de Proyectos',
                route: 'auxiliar2_list_project_manager_vhe',
                permission: 'view_auxiliars_vhe',
            },
            {
                title: 'Incidencias Mantenimiento Correctivo',
                route: 'auxiliar2_list_corrective_maintenance_incident_vhe',
                permission: 'view_auxiliars_vhe',
            },
        ]
    },
]
